import React, { Component } from 'react';
import './App.css';
import Hero from './components/Hero'
import About from './components/About'
import Projects from './components/Projects'
import Contact from './components/Contact'
import Reviews from './components/Reviews'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Hero/>
        <About/>
        <Projects/>
        <Reviews/>
        <Contact/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js